<template>
  <div>
    <div class="row no-gutters text-center">
      <template  v-if="$route.name === 'VesselAuditDue'">
      <div class="col pb-2">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setVesselsToTable(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setVesselsToTable(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setVesselsToTable(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
      </template>
      <div class="col-md-auto p-0 m-0">
        <div class="text-right p-0 m-0">
          <button id="committeeReport" class="mr-2 e-btn e-btn-primary force-white-all"
                  :disabled="allDuesCountRequested === false || vessel_audit_dues.length === 0"
                  :class="{ 'e-btn-blue-gray-disabled loading-bg' : allDuesCountRequested === false, 'e-btn-blue-gray-disabled' : vessel_audit_dues.length === 0}"
                  :title="allDuesCountRequested === false ? 'Preparing your download, please wait...' : ''"
                  @click="exportData"
          >
            <font-awesome-icon class="mr-1" icon="download"/>
            Download
          </button>
        </div>
      </div>

      <div class="col-md-auto">
        <div class="text-right">
          <select class="form-control form-control-sm" :class="{'select-null' : params.office_filter === null}" v-model="params.office_filter" @change="setVesselsToTable">
              <option :value="null" id="first-option">SELECT A BRANCH OFFICE</option>
              <template v-for="(data, index) in mngmntOfficeKeys">
                <option :value="data.id" class="text-uppercase">
                  {{ data.code ? data.code.toUpperCase() : '' }}
                </option>
              </template>
          </select>
        </div>
      </div>
      <div class="col-4 pb-2 pl-2" v-if="$route.name === 'VesselAuditDue'">
        <div class="search-container">
          <input
            :class="{ 'cursor-not-allowed' : allDuesCountRequested === false }"
            :disabled="allDuesCountRequested === false"
            :title="allDuesCountRequested === false ? 'Please wait for the due counts to finish first...' : ''"
            type="text"
            name="vesselSearch"
            class="form-control form-control-sm"
            v-model="params.query"
            placeholder="Search Vessel"
            @keypress.enter="setVesselsToTable"
          >
          <div class="search-icon" @click="setVesselsToTable">
            🔍
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="">
          <div class="">
            <div class="row">
              <div class="col-12">
                <div class="table-container text-center table-height" >
                  <table class="table mb-0 custom-padding">
                    <thead class="text-uppercase" style="position:sticky !important; z-index: 11">
                    <tr style="background-color: #e1e1e1">
                      <th class="fixed-col bottom-solid-border-black left-solid-border-black" rowspan="3"  style="background-color: #e1e1e1; vertical-align: middle; min-width: 30.83px !important;">#</th>
                      <th class="fixed-col bottom-solid-border-black" rowspan="3" @click="sortDateColumn('vessel','vessel_name')" style=" background-color: #e1e1e1; vertical-align: middle; min-width: 170px !important;">
                        Name
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'vessel_name'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'vessel_name'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="fixed-col bottom-solid-border-black" rowspan="3" style=" background-color: #e1e1e1; vertical-align: middle; min-width: 108px !important;">IMO No.</th>
                      <th class="fixed-col bottom-solid-border-black" rowspan="3" @click="sortDateColumn('vessel','flag')" style=" background-color: #e1e1e1; vertical-align: middle; min-width: 110px !important;">
                        Flag
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'flag'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'flag'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="fixed-col bottom-solid-border-black right-solid-border-black" rowspan="3" @click="sortDateColumn('vessel','office')" style=" background-color: #e1e1e1; vertical-align: middle; min-width: 130px !important;">
                        Branch Office
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'office'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'office'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>

                      <th colspan="3" style="width: 50%;height:98px;vertical-align: middle;font-size:1rem;" class="right-solid-border-black background-0000ff">SMS</th>
                      <th colspan="3" style="width: 50%;height:98px;vertical-align: middle;font-size:1rem;" class="right-solid-border-black background-548235">ISPS</th>
                      <th colspan="3" style="width: 50%;height:98px;vertical-align: middle;font-size:1rem;" class="right-solid-border-black background-dc3545">CYBER</th>
<!--                      <th colspan="6" rowspan="2" class="right-solid-border-black bottom-solid-border-black plan-content" style="vertical-align: middle;">Plan</th>-->
<!--                      DON'T REMOVE THIS TH-->
                      <th colspan="100%" rowspan="2" class="right-solid-border-black bottom-solid-border-black " style="vertical-align: middle;position: relative;">
                        <div class="row">
                          <div class="col-6 d-flex justify-content-end align-items-center">
                            <span style="font-size: 1.2rem;">INTERNAL AUDIT APPOINTMENT PLANNER</span>
                          </div>
                          <div class="col-6">
                            <div class="row">
                              <div class="col-6 d-flex align-items-center justify-content-end">
                                <table class="no-border-table custom-padding" style="text-align: left !important;text-transform: none !important;font-weight: normal !important; " >
                                  <tr>
                                    <td >
                                      <div class="box-legend appointed"> APPOINTED</div>
                                    </td>
                                    <td  >
                                      <div class="text-uppercase">
                                        An internal audit is scheduled to be conducted.
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="box-legend in-progress"> IN PROGRESS</div>
                                    </td>
                                    <td>
                                      <div class="text-uppercase">
                                        The internal audit has been completed, and currently preparing the report
                                      </div>
                                      <font-awesome-icon icon="question-circle"
                                                         data-toggle="modal"
                                                         style="cursor:pointer"
                                                         data-target="#inProgressDescription" >
                                      </font-awesome-icon>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="box-legend ready-to-close"> READY TO CLOSE</div>
                                    </td>
                                    <td>
                                      <div class="text-uppercase">
                                        This is requesting Lead Auditor to close an internal audit report
                                      </div>
                                      <font-awesome-icon icon="question-circle"
                                                         data-toggle="modal"
                                                         style="cursor:pointer"
                                                         data-target="#readyToCloseDescription" >
                                      </font-awesome-icon>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="box-legend closed">CLOSED</div>
                                    </td>
                                    <td>
                                      <div class="text-uppercase">
                                        An Internal audit report has been closed and audit schedule of INTERNAL AUDIT  APPOINTMENT PLANNER will be refreshed.
                                      </div>
                                      <font-awesome-icon icon="question-circle"
                                                         data-toggle="modal"
                                                         style="cursor:pointer"
                                                         data-target="#closeDescription" >
                                      </font-awesome-icon>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <div class="col-6 d-flex align-items-center justify-content-center">
                                <table style="border: none">
                                  <tr style="border: none">
                                    <td rowspan="2" style="border: none; color: red">LEGENDS: </td>
                                    <td style="border: none" class="p-0 pb-1">
                                      <div class="arrow-border mr-1" style="height: 30px; width: 30px">
                                        <div class="arrow-fill" style="background-color: #fff">
                                        </div>
                                      </div>
                                    </td>
                                    <td style="border: none" class="p-0 text-left">
                                      <div class="mr-1">
                                        <div>NOT COMPLETED / <br>NO DATA IN NC/OBS</div>
                                      </div>
                                    </td>
                                    <td style="border: none" class="p-0">
                                      <div class="arrow-border mr-1" style="height: 30px; width: 30px">
                                        <div class="arrow-fill" style="background-color: #00b0f0">
                                        </div>
                                      </div>
                                    </td>

                                    <td style="border: none" class="p-0 text-left">
                                      <div class="mr-1">
                                        <div>Required field <br>entry completed</div>
                                      </div>
                                    </td>

                                  </tr>
                                  <tr style="border: none">
                                    <td style="border: none" class="p-0">
                                      <div class="arrow-border mr-1" style="height: 30px; width: 30px">
                                        <div class="arrow-fill" style="background-color: #ffc000">
                                        </div>
                                      </div>
                                    </td>
                                    <td style="border: none" class="p-0 text-left">
                                      <div class="mr-1">
                                        <div>Number of NC / OBS</div>
                                      </div>
                                    </td>
                                    <td style="border: none" class="p-0 text-left">
                                      <div class="arrow-border mr-1" style="height: 30px; width: 30px">
                                        <div class="arrow-fill" style="background-color: #a6a6a6">
                                        </div>
                                      </div>
                                    </td>
                                    <td style="border: none" class="p-0 text-left">
                                      <div class="mr-1">
                                        <div>Report Already Closed</div>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr v-if="$route.name === 'VesselAuditDue'">
                      <th colspan="3" class="p-0 right-solid-border-black bottom-solid-border-black" style="min-width: 345px; background-color: #e1e1e1">
                        <div class="row col-12 m-auto p-0">
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'Overdue'"
                              :display-text-color="'#fffeff'"
                              :display-text-bg-color="'#f35656'"
                              :display-count="vessel_audit_dues_count.sms.overdue.count"
                              :display-count-color="'#fffeff'"
                              :display-count-bg-color="'#ff0000'"
                              :requesting="vessel_audit_dues_count.sms.overdue.requesting"
                            />
                          </div>
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'30 Days'"
                              :display-text-color="'#fffeff'"
                              :display-text-bg-color="'#ff8c00'"
                              :display-count="vessel_audit_dues_count.sms['30days'].count"
                              :display-count-color="'#fffeff'"
                              :display-count-bg-color="'#ffa500'"
                              :requesting="vessel_audit_dues_count.sms['30days'].requesting"
                            />
                          </div>
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'90 Days'"
                              :display-text-bg-color="'#fbfb98'"
                              :display-count="vessel_audit_dues_count.sms['90days'].count"
                              :display-count-bg-color="'#f3f309'"
                              :requesting="vessel_audit_dues_count.sms['90days'].requesting"
                            />
                          </div>
                        </div>
                      </th>
                      <th colspan="3" class="p-0 right-solid-border-black bottom-solid-border-black" style="min-width: 345px; background-color: #e1e1e1">
                        <div class="row col-12 m-auto p-0">
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'Overdue'"
                              :display-text-color="'#fffeff'"
                              :display-text-bg-color="'#f35656'"
                              :display-count="vessel_audit_dues_count.isps.overdue.count"
                              :display-count-color="'#fffeff'"
                              :display-count-bg-color="'#ff0000'"
                              :requesting="vessel_audit_dues_count.isps.overdue.requesting"
                            />
                          </div>
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'30 Days'"
                              :display-text-color="'#fffeff'"
                              :display-text-bg-color="'#ff8c00'"
                              :display-count="vessel_audit_dues_count.isps['30days'].count"
                              :display-count-color="'#fffeff'"
                              :display-count-bg-color="'#ffa500'"
                              :requesting="vessel_audit_dues_count.isps['30days'].requesting"
                            />
                          </div>
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'90 Days'"
                              :display-text-bg-color="'#fbfb98'"
                              :display-count="vessel_audit_dues_count.isps['90days'].count"
                              :display-count-bg-color="'#f3f309'"
                              :requesting="vessel_audit_dues_count.isps['90days'].requesting"
                            />
                          </div>
                        </div>
                      </th>
                      <th colspan="3" class="p-0 right-solid-border-black bottom-solid-border-black" style="min-width: 345px; background-color: #e1e1e1">
                        <div class="row col-12 m-auto p-0">
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'Overdue'"
                              :display-text-color="'#fffeff'"
                              :display-text-bg-color="'#f35656'"
                              :display-count="vessel_audit_dues_count.cyber.overdue.count"
                              :display-count-color="'#fffeff'"
                              :display-count-bg-color="'#ff0000'"
                              :requesting="vessel_audit_dues_count.cyber.overdue.requesting"
                            />
                          </div>
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'30 Days'"
                              :display-text-color="'#fffeff'"
                              :display-text-bg-color="'#ff8c00'"
                              :display-count="vessel_audit_dues_count.cyber['30days'].count"
                              :display-count-color="'#fffeff'"
                              :display-count-bg-color="'#ffa500'"
                              :requesting="vessel_audit_dues_count.cyber['30days'].requesting"
                            />
                          </div>
                          <div class="col-4 m-0 p-0">
                            <data-counter
                              :display-text="'90 Days'"
                              :display-text-bg-color="'#fbfb98'"
                              :display-count="vessel_audit_dues_count.cyber['90days'].count"
                              :display-count-bg-color="'#f3f309'"
                              :requesting="vessel_audit_dues_count.cyber['90days'].requesting"
                            />
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;" @click="sortDateColumn('sms','sms.next_due')" >
                        Next Due
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'sms.next_due'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'sms.next_due'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;" @click="sortDateColumn('sms','sms.last_audit_date.date-picker')">
                            Date of Last Audit
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'sms.last_audit_date.date-picker'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'sms.last_audit_date.date-picker'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1">Extension</th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer" @click="sortDateColumn('isps','isps.next_due')">
                        Next Due
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'isps.next_due'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'isps.next_due'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;" @click="sortDateColumn('isps','isps.last_audit_date.date-picker')">
                        Date of Last Audit
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'isps.last_audit_date.date-picker'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'isps.last_audit_date.date-picker'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1">Extension</th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer" @click="sortDateColumn('cyber','cyber.next_due')">
                        Next Due
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'cyber.next_due'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'cyber.next_due'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;" @click="sortDateColumn('cyber','cyber.last_audit_date.date-picker')">
                        Date of Last Audit
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'cyber.last_audit_date.date-picker'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'cyber.last_audit_date.date-picker'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="right-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1">Extension</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 110px">STATUS</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 200px">ACTION</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 90px">TYPE 2</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 110px">AUDIT</th>
                      <th class="bottom-solid-border-black right-solid-border-black">EXTENSION</th>
                      <th class="bottom-solid-border-black right-solid-border-black">EXTENSION APPROVAL</th>
                      <th class="bottom-solid-border-black right-solid-border-black">VOYAGE DATA</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="width: 300px; max-width: 300px !important;">PLAN REMARKS</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 90px">TYPE3</th>
                      <th class="bottom-solid-border-black right-solid-border-black" @click="sortDateColumn('planner','appointment_date')">
                        APPOINTMENT DATE
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'appointment_date'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'appointment_date'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="bottom-solid-border-black right-solid-border-black" @click="sortDateColumn('planner','audit_date_start')">
                        DATE OF AUDIT
                        <span style="cursor: pointer" class="h6 ml-2">
                          <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'audit_date_start'" class="sort-arrow-up"/>
                          <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'audit_date_start'" class="sort-arrow-down"/>
                          <font-awesome-icon icon="sort" v-else/>
                        </span>
                      </th>
                      <th class="bottom-solid-border-black right-solid-border-black">LEAD AUDITOR</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 110px">AUDITOR</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 110px">COUNTRY</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 110px">PORT</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 90px">AP</th>
                      <th class="bottom-solid-border-black right-solid-border-black">DO</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 90px">NC</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 90px">OBS</th>
                      <th class="bottom-solid-border-black right-solid-border-black" style="min-width: 90px">COR</th>
                      <th class="bottom-solid-border-black right-solid-border-black">COR DUE DATE</th>


<!--                      DONT REMOVE THESE TH-->
<!--                      <th class="plan-content bottom-solid-border-black right-solid-border-black" style="min-width: 300px !important">Place</th>-->
<!--                      <th class="plan-content bottom-solid-border-black right-solid-border-black" style="min-width: 300px !important">Auditors</th>-->
<!--                      <th class="plan-content bottom-solid-border-black right-solid-border-black">Date</th>-->
<!--                      <th class="plan-content bottom-solid-border-black right-solid-border-black">Remarks</th>-->
<!--                      <th class="plan-content bottom-solid-border-black right-solid-border-black">Last Updated By</th>-->
<!--                      <th class="plan-content bottom-solid-border-black right-solid-border-black">Updated At</th>-->
                    </tr>

                    <tr v-if="user.is_vessel === false || vessel_audit_dues.length > 1">
                      <th class="fixed-col left-solid-border-black bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;"></th>
                      <th class="fixed-col bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_name"
                          @callRequestFunction="setVesselsToTable"
                        />
                      </th>
                      <th class="fixed-col bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_imo_no"
                          @callRequestFunction="setVesselsToTable"
                        />
                      </th>
                      <th class="fixed-col bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_flag_name"
                          @callRequestFunction="setVesselsToTable"
                        />
                      </th>
                      <th class="fixed-col bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_branch_office_name"
                          @callRequestFunction="setVesselsToTable"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_sms_next_due"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_sms_last_audit_date"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_sms_extension"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_isps_next_due"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_isps_last_audit_date"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_isps_extension"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_cyber_next_due"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_cyber_last_audit_date"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.vessel_cyber_extension"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <select v-model="params.plan_status" class="form-control form-control-sm text-center" style="width: 160px;" @change="setVesselsToTable">
                              <option :value="null" :selected="true">-- ALL --</option>
                              <option v-for="(reportStatusKey, index) in reportStatusKeyModify" :key="index" :value="reportStatusKey.id">{{reportStatusKey.name}}</option>
                            </select>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;"></th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <select v-model="params.plan_type_2" class="form-control form-control-sm text-center" style="width: auto;padding: 0;" @change="setVesselsToTable">
                              <option :value="null" :selected="true">-- ALL --</option>
                              <option value="a">A - ANNUAL</option>
                              <option value="o">O - OCCASIONAL</option>
                              <option value="n">N - NAVIGATIONAL AUDIT</option>
                            </select>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <select v-model="params.plan_audit_type" class="form-control form-control-sm text-center" style="width: auto;padding: 0;" @change="setVesselsToTable">
                              <option :value="null" :selected="true">-- ALL --</option>
                              <option value="sms">SMS</option>
                              <option value="isps">ISPS</option>
                              <option value="cyber">CYBER</option>
                            </select>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_extension"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;"></th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.voyage_data"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_remarks"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <select v-model="params.plan_type_3" class="form-control form-control-sm text-center" style="width: auto;padding: 0;" @change="setVesselsToTable">
                              <option :value="null" :selected="true">-- ALL --</option>
                              <option value="o">O - Onsite</option>
                              <option value="r">R - Remote</option>
                            </select>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <date-picker id = "date-picker" :lang="en" type="date" :style="{ width: '200px' }" valueType="format" range v-model="dateRangePlanAppointmentDate" @change="setVesselsToTable" lang="en"></date-picker>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <date-picker id = "date-picker" :lang="en" type="date" :style="{ width: '200px' }" valueType="format" range v-model="dateRangePlanDateOfAudit" @change="setVesselsToTable" lang="en"></date-picker>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>

<!--                        plan_lead_auditor-->
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_lead_auditor"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_non_lead_auditor"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />

<!--                        plan_country_name-->
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_country_name"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_port_name"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_ap"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <select class="form-control form-control-sm text-center" v-model="params.plan_do" style="width: 160px;" @change="setVesselsToTable">
                              <option :value="null" :selected="true">-- ALL --</option>
                              <option value="0">NOT IMPLEMENTED</option>
                              <option value="1">DONE</option>
                            </select>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_nc"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <table-column-search
                          v-model="params.plan_obs"
                          @callRequestFunction="setVesselsToTable"
                          :x_button_z_index="9"
                        />
                      </th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;"></th>
                      <th class="z-index-7 bottom-solid-border-black" style="background-color: #e1e1e1; cursor: pointer;">
                        <div class="d-flex align-items-center w-auto">
                          <div class="input-group position-relative">
                            <date-picker id = "date-picker" :lang="en" type="date" :style="{ width: '200px' }" valueType="format" v-model="params.plan_cor_due_date" @change="setVesselsToTable" lang="en"></date-picker>
                          </div>
                          <font-awesome-icon
                            class="ml-2"
                            icon="filter"
                            style="cursor: pointer;"
                            @click.prevent="setVesselsToTable"
                          />
                        </div>
                      </th>
                    </tr>

                    </thead>
                    <tbody>
<!--                    <template v-if="loading">-->
<!--                      <tr>-->
<!--                        <td colspan="100%">-->
<!--                          <app-loading></app-loading>-->
<!--                        </td>-->
<!--                      </tr>-->
<!--                    </template>-->
                    <template v-if="vessel_audit_dues.length === 0">
                      <tr v-if="loading === false">
                        <td colspan="100%" class="align-middle font-weight-bold bg-secondary"><span class="text-white float-left" style="margin-left : 800px">NO RESULTS FOUND</span></td>
                      </tr>
                    </template>
                    <template v-else>
                      <template>
                        <template v-for="(vessel, index) in vessel_audit_dues">
                          <template v-if="vessel.internal_audit_planner.audit_types.length === 0">
                            <tr :title="vessel.vessel_name" @mouseover="highlightRow(index, true)" @mouseout="highlightRow(index, false)">
                              <td :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center left-solid-border-black" style="min-width: 10px !important;">{{ index + pagination.from }}</td>
                              <td :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center" style="min-width: 170px !important;">{{ vessel.vessel_name ?? ''}}</td>
                              <td :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center" style="min-width: 108px !important;">{{ vessel.vessel_imo_no?? '-' }}</td>
                              <td :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center" style="min-width: 110px !important;">{{ vessel.flag ?? '' }}</td>
                              <td :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center right-solid-border-black" style="min-width: 130px !important;">{{ vessel.office ? vessel.office : '' }}</td>
                              <td :class="['row_' + index, getDueClassColor(vessel.sms)]">{{ vessel.sms.next_due ?? ''}}</td>
                              <td :class="'row_' + index"><a class="text-underlined" @click="viewAuditRecord(vessel.id, vessel.sms.audit_id, 'sms')">{{ vessel.sms.last_audit_date === null ? '' : vessel.sms.last_audit_date.human }}</a></td>
                              <td class="right-solid-border-black" :class="'row_' + index" :style="vessel.sms.extension === 1 ? 'color: red;' : ''">{{ vessel.sms.extension === null ? '' : vessel.sms.extension === 1 ? vessel.sms?.extended_date?.human : 'NO'}}</td>
                              <td :class="['row_' + index, getDueClassColor(vessel.isps)]">{{ vessel.isps.next_due ?? ''}}</td>
                              <td :class="'row_' + index"><a class="text-underlined" @click="viewAuditRecord(vessel.id, vessel.isps.audit_id, 'isps')">{{ vessel.isps.last_audit_date === null ? '' : vessel.isps.last_audit_date.human }}</a></td>
                              <td :class="'row_' + index" class="right-solid-border-black" :style="vessel.isps.extension === 1 ? 'color: red;' : ''">{{ vessel.isps.extension === null ? '' : vessel.isps.extension === 1 ? vessel.isps?.extended_date?.human : 'NO'}}</td>
                              <td :class="['row_' + index, getDueClassColor(vessel.cyber)]">{{ vessel.cyber.next_due ?? ''}}</td>
                              <td :class="'row_' + index"><a class="text-underlined" @click="viewAuditRecord(vessel.id, vessel.cyber.audit_id, 'cyber')">{{ vessel.cyber.last_audit_date === null ? '' : vessel.cyber.last_audit_date.human }}</a></td>
                              <td :class="'row_' + index" class="right-solid-border-black" :style="vessel.cyber.extension === 1 ? 'color: red;' : ''">{{ vessel.cyber.extension === null ? '' : vessel.cyber.extension === 1 ? vessel.cyber?.extended_date?.human : 'NO'}}</td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0">
                                <button id="committeeReport" class="mr-2 e-btn e-btn-primary force-white-all"
                                        :title="isAllowed('vessel-ia.appointments.audit-records.create') === true ? vessel.vessel_name : 'You are not allowed to create new appointment'"
                                        :class="[isAllowed('vessel-ia.appointments.audit-records.create') === true ? '' : 'e-btn-blue-disabled cursor-not-allowed']"
                                        :disabled="isAllowed('vessel-ia.appointments.audit-records.create') === false"
                                        @click="createNewAppointment(vessel.id)"
                                >
                                  Create New Appointment
                                </button>
                              </td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>
                              <td :class="'row_' + index" class="py-0 px-1 m-0"></td>



                              <!--                            DONT REMOVE THESE TD-->
                              <!--                            <td :class="'row_' + index" class="plan-content" style="white-space: normal !important; overflow-wrap: break-word; word-break: break-all;" @dblclick="showUpdateVesselPlanModal(vessel)">{{ vessel.plan?.place ? vessel.plan?.place : '' }}</td>-->
                              <!--                            <td :class="'row_' + index" class="plan-content" style="white-space: normal !important; overflow-wrap: break-word; word-break: break-all;" @dblclick="showUpdateVesselPlanModal(vessel)">{{ vessel.plan?.auditors.map(auditor => auditor.name).join(' & ') }}</td>-->
                              <!--                            <td :class="'row_' + index" class="plan-content" @dblclick="showUpdateVesselPlanModal(vessel)">{{ vessel.plan?.date?.human ? vessel.plan?.date?.human : null }}</td>-->
                              <!--                            <td :class="'row_' + index" class="plan-content" style="min-width: 300px !important; white-space: normal !important; overflow-wrap: break-word; word-break: break-all;" @dblclick="showUpdateVesselPlanModal(vessel)">{{ vessel.plan?.remarks ? vessel.plan?.remarks : '' }}</td>-->
                              <!--                            <td :class="'row_' + index" class="plan-content">{{ vessel.plan?.last_updated_by ? vessel.plan?.last_updated_by : '' }}</td>-->
                              <!--                            <td :class="'row_' + index" class="plan-content right-solid-border-black">{{ vessel.plan?.last_updated_at ? vessel.plan?.last_updated_at : '' }}</td>-->
                            </tr>

                          </template>
                          <template v-else>
                            <template v-for="(audit_planner, audit_planner_index) in vessel.internal_audit_planner.audit_types">
                              <tr :title="vessel.vessel_name" @mouseover="highlightRow(index, true)" @mouseout="highlightRow(index, false)">
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center left-solid-border-black" style="min-width: 10px !important;">{{ index + pagination.from }}</td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center" style="min-width: 170px !important;">{{ vessel.vessel_name ?? ''}}</td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center" style="min-width: 108px !important;">{{ vessel.vessel_imo_no?? '-' }}</td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center" style="min-width: 110px !important;">{{ vessel.flag ?? '' }}</td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index" class="fixed-col text-uppercase text-wrap text-center right-solid-border-black" style="min-width: 130px !important;">{{ vessel.office ? vessel.office : '' }}</td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="['row_' + index, getDueClassColor(vessel.sms)]">
                                  {{ vessel.sms.next_due ?? ''}}
<!--                                  <span v-if="(vessel?.sms?.generated_vpi_score !== null && vessel?.sms?.generated_vpi_score < 2) || vessel?.sms?.generated_base_audit_from !== null">-->
                                  <span v-if="vessel?.sms?.generated_vpi_score !== null && vessel?.sms?.generated_vpi_score < 2">
                                    <font-awesome-icon
                                      @click="setNextDueDateDataModal(vessel, 'sms')"
                                      icon="question-circle"
                                      data-toggle="modal"
                                      style="cursor:pointer"
                                      data-target="#nextDueDateDataModal">
                                    </font-awesome-icon>
                                  </span>
                                </td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index">
                                  <a class="text-underlined" @click="viewAuditRecord(vessel.id, vessel.sms.audit_id, 'sms')">
                                    {{ vessel.sms.last_audit_date === null ? '' : vessel.sms.last_audit_date.human }}
                                  </a>
                                  <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.sms?.last_audit_type_3 === 2">&nbsp;R&nbsp;</span>
                                </td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" class="right-solid-border-black" :class="'row_' + index" :style="vessel.sms.extension === 1 ? 'color: red;' : ''">{{ vessel.sms.extension === null ? '' : vessel.sms.extension === 1 ? vessel.sms?.extended_date?.human : 'NO'}}</td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="['row_' + index, getDueClassColor(vessel.isps)]">
                                  {{ vessel.isps.next_due ?? ''}}

<!--                                  <span v-if="(vessel?.isps?.generated_vpi_score !== null && vessel?.isps?.generated_vpi_score < 2) || vessel?.isps?.generated_base_audit_from !== null">-->
                                  <span v-if="vessel?.isps?.generated_vpi_score !== null && vessel?.isps?.generated_vpi_score < 2">
                                    <font-awesome-icon
                                      @click="setNextDueDateDataModal(vessel, 'isps')"
                                      icon="question-circle"
                                      data-toggle="modal"
                                      style="cursor:pointer"
                                      data-target="#nextDueDateDataModal">
                                    </font-awesome-icon>
                                  </span>
                                </td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index">
                                  <a class="text-underlined" @click="viewAuditRecord(vessel.id, vessel.isps.audit_id, 'isps')">
                                    {{ vessel.isps.last_audit_date === null ? '' : vessel.isps.last_audit_date.human }}
                                  </a>
                                  <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.isps?.last_audit_type_3 === 2">&nbsp;R&nbsp;</span>
                                </td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index" class="right-solid-border-black" :style="vessel.isps.extension === 1 ? 'color: red;' : ''">{{ vessel.isps.extension === null ? '' : vessel.isps.extension === 1 ? vessel.isps?.extended_date?.human : 'NO'}}</td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="['row_' + index, getDueClassColor(vessel.cyber)]">
                                  {{ vessel.cyber.next_due ?? ''}}

<!--                                  <span v-if="(vessel?.cyber?.generated_vpi_score !== null && vessel?.cyber?.generated_vpi_score < 2) || vessel?.cyber?.generated_base_audit_from !== null">-->
                                  <span v-if="vessel?.cyber?.generated_vpi_score !== null && vessel?.cyber?.generated_vpi_score < 2">
                                    <font-awesome-icon
                                      @click="setNextDueDateDataModal(vessel, 'cyber')"
                                      icon="question-circle"
                                      data-toggle="modal"
                                      style="cursor:pointer"
                                      data-target="#nextDueDateDataModal">
                                    </font-awesome-icon>
                                  </span>
                                </td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index">
                                  <a class="text-underlined" @click="viewAuditRecord(vessel.id, vessel.cyber.audit_id, 'cyber')">
                                    {{ vessel.cyber.last_audit_date === null ? '' : vessel.cyber.last_audit_date.human }}
                                  </a>
                                  <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.cyber?.last_audit_type_3 === 2">&nbsp;R&nbsp;</span>
                                </td>
                                <td :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0" :class="'row_' + index" class="right-solid-border-black" :style="vessel.cyber.extension === 1 ? 'color: red;' : ''">{{ vessel.cyber.extension === null ? '' : vessel.cyber.extension === 1 ? vessel.cyber?.extended_date?.human : 'NO'}}</td>
                                <td
                                  @click="redirectToMainReport(vessel, audit_planner)"
                                  class="p-0 m-0 redirect-column cursor-pointer"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'report_status_id') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'report_status_id')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'report_status_id'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'report_status_id')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'report_status_id')).length"
                                  :class="['bg-' + reportStatusKeys.filter(item => item.id === audit_planner?.report_status_id)[0]?.color]">

                                  {{ updated_report_status_names.filter(item => {
                                  return item.id === audit_planner?.report_status_id
                                })[0]?.name ?? 'APPOINTED' }}
                                </td>
                                <td class="p-0 m-0" :class="'row_' + index" :rowspan="vessel.internal_audit_planner.audit_types.length" v-if="audit_planner_index === 0">
                                  <button id="committeeReport" class="mr-2 e-btn e-btn-primary force-white-all"
                                          :title="isAllowed('vessel-ia.appointments.audit-records.create') === false ? 'You are not allowed to create new appointment' : vessel.vessel_name"
                                          :class="[isAllowed('vessel-ia.appointments.audit-records.create') === false ? 'e-btn-blue-disabled cursor-not-allowed' : '', {'bg-secondary': disableCreateAppointmentWhenTypeIsNew(vessel?.internal_audit_planner?.audit_types)}]"
                                          :disabled="isAllowed('vessel-ia.appointments.audit-records.create') === false || disableCreateAppointmentWhenTypeIsNew(vessel?.internal_audit_planner?.audit_types)"
                                          @click="createNewAppointment(vessel.id)"
                                  >
                                    Create New Appointment
                                  </button>
                                </td>
                                <td
                                  class="p-0 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_2') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_2')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_2'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_2')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_2')).length"
                                  :class="'row_' + index">
                                  <div :title="convertAuditType2IntoType(audit_planner.audit_type_2[0]).name" class="circle-badge" :style="{backgroundColor : convertAuditType2IntoType(audit_planner.audit_type_2[0]).color }">
                                    {{ convertAuditType2IntoType(audit_planner.audit_type_2[0]).text }}
                                  </div>
                                </td>

                                <td
                                  @click="redirectToMainReport(vessel, audit_planner, false)"
                                  class="cursor-pointer text-white p-0 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'type_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'type_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'type_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'type_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'type_value')).length"
                                  :class="[audit_planner.report_status_id === 3 ? 'row_' + index : '', audit_planner.report_status_id !== 3 ? 'redirect-column' : '']"
                                  :style="{backgroundColor : audit_planner.report_status_id === 3 ? '' : typeColors[audit_planner.type]}"
                                >
                                  {{ audit_planner.report_status_id === 3 ? '' : audit_planner.type.toUpperCase() }}
                                </td>

                                <td
                                  class="p-1 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'is_extended_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'is_extended_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'is_extended_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'is_extended_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'is_extended_value')).length"
                                  :class="'row_' + index">
                                  <div :title="audit_planner.is_extended === 1 ? `Extended until ${audit_planner?.extended_date?.human}` : ''" class="circle-badge" :style="{backgroundColor : audit_planner.is_extended === 1 ? '#a14aa0' : ''}">
                                    {{ audit_planner.is_extended === 1 ? 'E' : '' }}
                                  </div>
                                </td>

                                <td
                                  class="p-1 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'extension_approval_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'extension_approval_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'extension_approval_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'extension_approval_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'extension_approval_value')).length"
                                  :class="'row_' + index">
                                  <font-awesome-icon
                                    v-if="audit_planner.extension_approval_url !== null"
                                    @click="viewEvidenceOfApproval(audit_planner.extension_approval_url)"
                                    icon="file-pdf" size="2x" class="force-danger-all" style="cursor: pointer"
                                  ></font-awesome-icon>
                                </td>

                                <td
                                  id = "voyage_data_td"
                                  @dblclick="editVoyageData(index, vessel)"
                                  class="p-0 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'voyage_data') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'voyage_data')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'voyage_data'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'voyage_data')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'voyage_data')).length"
                                  :class="'row_' + index">
                                  <div class="p-1 pre-wrap-txt" style="width: 300px; max-width: 300px !important; list-style-position: inside; padding-left: 0; margin: 0;" v-html="audit_planner.voyage_data"></div>
                                </td>

                                <td
                                  id = "plan_remarks_td"
                                  @dblclick="editPlanRemarks(index, vessel)"
                                  class="p-0 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'plan_remarks') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'plan_remarks')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'plan_remarks'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'plan_remarks')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'plan_remarks')).length"
                                  :class="'row_' + index">
                                  <div class="p-1 pre-wrap-txt" style="width: 300px; max-width: 300px !important; list-style-position: inside; padding-left: 0; margin: 0;" v-html="audit_planner.plan_remarks"></div>
                                </td>

                                <td
                                  class="p-0 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_3') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_3')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_3'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_3')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_type_3')).length"
                                  :class="'row_' + index">
                                  <div :title="convertAuditType3IntoType(audit_planner.audit_type_3[0]).name" class="circle-badge" :style="{backgroundColor : convertAuditType3IntoType(audit_planner.audit_type_3[0]).color }">
                                    {{ convertAuditType3IntoType(audit_planner.audit_type_3[0]).text }}
                                  </div>
                                </td>




                                <td
                                  class="p-0 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'appointment_date_picker') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'appointment_date_picker')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'appointment_date_picker'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'appointment_date_picker')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'appointment_date_picker')).length"
                                  :class="'row_' + index">
                                  {{ audit_planner.appointment_date.human }}
                                </td>

                                <td
                                  class="py-0 px-1 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_start_end_date') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_start_end_date')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_start_end_date'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_start_end_date')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_start_end_date')).length"
                                  :class="'row_' + index">
                                  {{ audit_planner.audit_date_start.human === audit_planner.audit_date_end.human ? audit_planner.audit_date_end.human : audit_planner.audit_date_start.human + ' - ' + audit_planner.audit_date_end.human }}
                                </td>

                                <td
                                  class="py-0 px-1 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids', 1) &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids', 1)[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids', 1))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids', 1)) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids', 1)).length"
                                  :class="'row_' + index">
                                  <div v-for="auditor in Object.values(audit_planner.auditors.filter(auditor => auditor.pivot.is_lead === 1).reduce((acc, curr) => {
                                    acc[curr.id] = acc[curr.id] || curr;
                                    return acc;
                                  }, {})
                                )" class="text-center">
                                    <template v-if="auditor?.pivot?.is_lead === 1">
                                      {{ auditor.name }}
                                    </template>
                                  </div>

                                </td>

                                <td
                                  class="py-0 px-1 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'auditor_ids')).length"
                                  :class="'row_' + index">
                                  <div v-for="auditor in Object.values(audit_planner.auditors.filter(auditor => auditor?.pivot?.is_lead === 0).reduce((acc, curr) => {
                                    acc[curr.id] = acc[curr.id] || curr;
                                    return acc;
                                  }, {})
                                )" class="text-center">
                                    <template v-if="auditor?.pivot?.is_lead === 0">
                                      {{ auditor.name }}
                                    </template>
                                  </div>
                                </td>

                                <td
                                  class="py-0 px-1 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'country_id') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'country_id')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'country_id'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'country_id')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'country_id')).length"
                                  :class="'row_' + index">
                                  {{ audit_planner.country?.name }}
                                </td>

                                <td
                                  class="py-0 px-1 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'port_id') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'port_id')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'port_id'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'port_id')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'port_id')).length"
                                  :class="'row_' + index">
                                  {{ audit_planner.port?.name }}
                                </td>

                                <td
                                  class="p-0 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')).length"
                                  :class="'row_' + index">
                                  <div class="arrow-border" v-if="audit_planner.report_status_id !== 3">
                                    <div class="arrow-fill" :style="{backgroundColor : getNcrObsBgColor(audit_planner)}">
                                      1
                                    </div>
                                  </div>
                                </td>

                                <td
                                  class="p-2 m-0"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_done') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_done')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_done'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_done')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'audit_done')).length"
                                  :class="'row_' + index">

                                  <template v-if="audit_planner.report_status_id !== 3">
                                    <template v-if="user.id === audit_planner.created_by_id || isAllowed('vessel-ia.appointment.appointment.edit-details')">
                                      <div class="d-flex align-items-center mb-0">
                                        <select
                                          id="audit_done_select"
                                          class="cursor-pointer form-control form-control-xs w-auto m-auto text-center"
                                          v-model="audit_planner.is_audit_done"
                                        >
                                          <option :value="0">NOT IMPLEMENTED</option>
                                          <option :value="1">DONE</option>
                                        </select>
                                        <template v-if="audit_planner.is_audit_done !== audit_planner.orig_is_audit_done">
                                          <span
                                            class="ml-2"
                                          >
                                          <font-awesome-icon
                                            @click="saveAuditDoneChanges(audit_planner)"
                                            icon="check"
                                            size="1x"
                                            class="e-text-green"
                                            id="check-icon"
                                          />
                                        </span>
                                          <span
                                            class="ml-1"
                                          >
                                   <span
                                     @click="audit_planner.is_audit_done = audit_planner.orig_is_audit_done"
                                     class="cancel-edit-button" aria-hidden="true">&times;</span>
                                        </span>
                                        </template>

                                      </div>
                                    </template>
                                    <template v-else>
                                      {{ audit_planner.is_audit_done === 1 ? 'DONE' : 'NOT IMPLEMENTED' }}
                                    </template>
                                    <div>
                                      {{ audit_planner.audit_date_start.human === audit_planner.audit_date_end.human ? audit_planner.audit_date_end.human : audit_planner.audit_date_start.human + ' - ' + audit_planner.audit_date_end.human }}
                                    </div>
                                  </template>
                                </td>

                                <td
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')).length"
                                  class="p-0 m-0"
                                  :class="['row_' + index]">
                                    <div class="arrow-border" v-if="audit_planner.report_status_id !== 3">
                                      <div class="arrow-fill" :style="{backgroundColor : getNcrObsBgColor(audit_planner, 'NCR')}">
                                        {{ audit_planner.ncr_count }}
                                      </div>
                                    </div>
                                </td>

                                <td
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')).length"
                                  class="p-0 m-0"
                                  :class="['row_' + index]">
                                  <div class="arrow-border" v-if="audit_planner.report_status_id !== 3">
                                    <div class="arrow-fill" :style="{backgroundColor : getNcrObsBgColor(audit_planner, 'OBS')}">
                                      {{ audit_planner.obs_count }}
                                    </div>
                                  </div>
                                </td>
                                <td
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ap_ncr_obs_cor_value')).length"
                                  class="p-0 m-0"
                                  :class="['row_' + index]">
                                  <div class="arrow-border" v-if="audit_planner.report_status_id !== 3">
                                    <div class="arrow-fill" :style="{backgroundColor : getNcrObsBgColor(audit_planner, 'COR')}">

                                    </div>
                                  </div>
                                </td>
                                <td
                                  :style="{ backgroundColor : computeCorDueDateFromToday(audit_planner).color, color : computeCorDueDateFromToday(audit_planner).color === '' ? '' : 'white' }"
                                  class="p-0 m-0"
                                  :class="[audit_planner.report_status_id === 3 || computeCorDueDateFromToday(audit_planner).color === '' ? 'row_' + index : '']"
                                  v-if="(
                                    audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ca_done_later_than_date_value') &&
                                    getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ca_done_later_than_date_value')[audit_planner.type] === true
                                    )
                                    ||
                                    !(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ca_done_later_than_date_value'))"
                                  :rowspan="!(audit_planner.type in getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ca_done_later_than_date_value')) ? 1 : Object.keys(getSameDataFromType(vessel.internal_audit_planner.audit_types, 'ca_done_later_than_date_value')).length"
                                  >
                                  <template v-if="(audit_planner.audit_report.has_ncr_obs === true || audit_planner.audit_report.has_ncr_obs === 1) && audit_planner?.audit_report?.ca_done_later_than.human !== null">
                                    {{ audit_planner?.audit_report?.ca_done_later_than.human }}
                                  </template>
                                </td>

                              </tr>
                            </template>
                          </template>
                           </template>
                      </template>
                    </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" data-backdrop="static" data-keyboard="false" id="updateVesselPlanModal" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <form class="modal-content" @submit.prevent="updateVesselPlan">
          <div class="modal-header">
            <div class="modal-title w-100 text-center">
              <h5 class="font-weight-bold">VESSEL ({{ selectedVesselForPlan.vessel_name }}) PLAN</h5>
            </div>
          </div>
          <div class="modal-body">
            <!--          FOR PLAN PLACE -->
            <div class="form-group row no-gutters mb-1">
              <label for="last_name" class="font-weight-bold col-sm-3 col-form-label text-left">PLACE</label>
              <div class="col-sm-9">
                <input type="text" id="plan_place" class="form-control form-control-sm" v-model="selectedVesselForPlan.place">
              </div>
            </div>
            <!--          FOR PLAN AUDITORS -->
            <div class="form-group row no-gutters mb-1">
              <label for="plan_auditors" class="font-weight-bold col-sm-3 col-form-label text-left">AUDITORS</label>
              <div class="col-sm-9">
                <multi-select-with-search
                  :key="selectedVesselForPlan.vessel_id + '_' + resetButtonClick"
                  id="plan_auditors"
                  :items="leadAndNonLeadAuditors" :entity="'Auditors'"
                  @doneSelected="setPlanAuditors"
                  :selected="selectedVesselForPlan.auditors"
                >
                </multi-select-with-search>
              </div>



            </div>
            <!--          FOR PLAN DATE -->
            <div class="form-group row no-gutters mb-1">
              <label for="management_office_id" class="font-weight-bold col-sm-3 col-form-label text-left">DATE</label>
              <div class="col-sm-9">
                <input type="date" :min="minimumDate"  class="form-control form-control-sm" v-model="selectedVesselForPlan.date">
              </div>
            </div>
            <!--          FOR PLAN REMARKS -->
            <div class="form-group row no-gutters mb-1">
              <label for="last_name" class="font-weight-bold col-sm-3 col-form-label text-left">REMARKS</label>
              <div class="col-sm-9">
                <input type="text" id="plan_remarks" class="form-control form-control-sm" v-model="selectedVesselForPlan.remarks">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-success" @click.prevent="setDefaultData">Reset</button>
            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="resetSelectedVesselPlan">Close</button>
            <button type="submit" class="btn btn-sm btn-primary" :class="hasChanges === false ? 'e-btn-blue-disabled' : ''" :disabled="hasChanges === false">Update Vessel Plan</button>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" data-backdrop="static" data-keyboard="false" id="editPlanRemarksModal" tabindex="-1">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <form class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ editPlanRemarksModalData.vessel_name }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePlanRemarksModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
            <table class="w-100">
              <thead class="text-uppercase">
              <tr style="background-color: #e1e1e1">
                <th class="text-center left-solid-border-black right-solid-border-black top-solid-border-black bottom-solid-border-black" style="width: 110px">AUDIT</th>
                <th class="text-center right-solid-border-black top-solid-border-black bottom-solid-border-black">PLAN REMARKS</th>
                <th class="text-center right-solid-border-black top-solid-border-black bottom-solid-border-black">ACTION</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in editPlanRemarksModalData.data">
                <td class="text-uppercase text-center text-white left-solid-border-black right-solid-border-black bottom-solid-border-black"
                    :style="{backgroundColor : typeColors[item.type]}"
                > {{ item.type }}</td>
                <td style="width: 100%;" class="right-solid-border-black bottom-solid-border-black">
                  <display-mode-vue-editor
                    v-if="item.edit === false"
                    :html-content="item.original_plan_remarks"
                  />
                  <vue-editor
                    v-else
                    v-model="item.plan_remarks" class="my-2" :editor-toolbar="toolbar">
                  </vue-editor>
                </td>
                <td class="text-center right-solid-border-black bottom-solid-border-black">
                  <template v-if="item.edit === false">
                    <button class="e-btn e-btn-green" type="button" @click="item.edit = true;">Edit</button>
                  </template>
                  <template v-else>
                    <button class="e-btn e-btn-outlined-red" type="button" @click="cancelEditPlanRemarks(item)">Cancel
                    </button>
                    <button class="e-btn e-btn-blue ml-2" type="button" @click="savePlanRemark(item)" :class="DataService.normalizeHtml(item.plan_remarks) === DataService.normalizeHtml(item.original_plan_remarks) ? 'e-btn-blue-disabled' : ''" :disabled="DataService.normalizeHtml(item.plan_remarks) === DataService.normalizeHtml(item.original_plan_remarks)">Save</button>
                  </template>

                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" data-backdrop="static" data-keyboard="false" id="editVoyageDataModal" tabindex="-1">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <form class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ editVoyageModalData.vessel_name }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVoyageDataModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
            <table class="w-100">
              <thead class="text-uppercase">
              <tr style="background-color: #e1e1e1">
                <th class="text-center left-solid-border-black right-solid-border-black top-solid-border-black bottom-solid-border-black" style="width: 110px">AUDIT</th>
                <th class="text-center right-solid-border-black top-solid-border-black bottom-solid-border-black">VOYAGE DATA</th>
                <th class="text-center right-solid-border-black top-solid-border-black bottom-solid-border-black">ACTION</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in editVoyageModalData.data">
                <td class="text-uppercase text-center text-white left-solid-border-black right-solid-border-black bottom-solid-border-black"
                    :style="{backgroundColor : typeColors[item.type]}"
                > {{ item.type }}</td>
                <td style="width: 100%;" class="right-solid-border-black bottom-solid-border-black">
                  <display-mode-vue-editor
                    v-if="item.edit === false"
                    :html-content="item.original_voyage_data"
                  />
                  <vue-editor
                    v-else
                    v-model="item.voyage_data" class="my-2" :editor-toolbar="toolbar">
                  </vue-editor>
                </td>
                <td class="text-center right-solid-border-black bottom-solid-border-black">
                  <template v-if="item.edit === false">
                    <button class="e-btn e-btn-green" type="button" @click="item.edit = true;">Edit</button>
                  </template>
                  <template v-else>
                    <button class="e-btn e-btn-outlined-red" type="button" @click="cancelEditVoyageData(item)">Cancel
                    </button>
                    <button class="e-btn e-btn-blue ml-2" type="button" @click="saveVoyageData(item)" :class="DataService.normalizeHtml(item.voyage_data) === DataService.normalizeHtml(item.original_voyage_data) ? 'e-btn-blue-disabled' : ''" :disabled="DataService.normalizeHtml(item.voyage_data) === DataService.normalizeHtml(item.original_voyage_data)">Save</button>
                  </template>

                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
          </div>
        </form>
      </div>
    </div>

    <PopperModal popper-id="inProgressDescription" class="text-uppercase">
      <template #popperHeader>
        <div class="box-legend in-progress"> IN PROGRESS</div>
      </template>
      <template #popperBody>
        <div class="popper-container">
           <p  class="p-1 m-0">
             The internal audit has been completed, and currently preparing the report
           </p>
          <p style="color:red;" class="p-1 m-0">
            The Auditor shall immediately change the Status from APPOINTED to IN PROGRESS after the internal audit is completed, regardless of whether the report is finalized.
          </p>
          <p style="color:red;font-weight: bold;text-decoration: underline;" class="p-1 m-0">
            The NEXT DUE date for internal audits is automatically updated at this time.
          </p>
        </div>
      </template>
      <template #popperFooter>
      </template>
    </PopperModal>
    <PopperModal popper-id="readyToCloseDescription" class="text-uppercase">
      <template #popperHeader>
        <div class="box-legend ready-to-close"> READY TO CLOSE</div>
      </template>
      <template #popperBody>
        <div class="popper-container">
          <p class="p-1 m-0">
            This is requesting Lead Auditor to close an internal audit report.
          </p>
        </div>
      </template>
      <template #popperFooter>
      </template>
    </PopperModal>
    <PopperModal popper-id="closeDescription" class="text-uppercase">
      <template #popperHeader>
        <div class="box-legend closed">CLOSED</div>
      </template>
      <template #popperBody>
        <div class="popper-container">
          <p class="p-1 m-0">
            An Internal audit report has been closed and <span style="color:red;font-weight: bold;text-decoration: underline;">audit schedule of INTERNAL AUDIT  APPOINTMENT PLANNER will be refreshed.</span>
          </p>
        </div>
      </template>
      <template #popperFooter>
      </template>
    </PopperModal>

    <PopperModal popper-id="nextDueDateDataModal" class="text-uppercase" popper-size="modal-md">
      <template #popperHeader>
        <h3>{{ nextDueDateDataModal?.vessel_name }} ({{ nextDueDateDataModal?.type}})</h3>
      </template>
      <template #popperBody>
        <div class="popper-container">
          <template v-if="nextDueDateDataModal?.typeData?.generated_vpi_score < 2">
            <p class="p-1 m-0" >
              VPI SCORE: <span style="font-weight: bold; font-size: 13px">{{ nextDueDateDataModal?.typeData?.generated_vpi_score }}</span>
            </p>
            <p class="p-1 m-0">
              DATE OF LAST AUDIT: <span style="font-weight: bold; font-size: 13px">{{ nextDueDateDataModal?.typeData?.last_audit_date['human'] }}</span>
            </p>

            <p class="p-1 m-0">
              NEXT AUDIT DUE: <span style="font-weight: bold; font-size: 13px">{{ nextDueDateDataModal?.typeData?.last_audit_date['human']}} + 3 months = {{ nextDueDateDataModal?.typeData?.next_due }}</span>
            </p>
          </template>
          <template v-else>
            <p class="p-1 m-0">
              NEXT AUDIT DUE: <span style="font-weight: bold; font-size: 13px"> {{ nextDueDateDataModal?.typeData?.next_due }}</span>
            </p>
            <div>
              <hr>
              <h6>BASE FROM:</h6>
              <p class="p-1 m-0" >
                - REPORT NUMBER: <span style="font-weight: bold; font-size: 13px">
                <a href="#" @click="openBaseReportForAuditNextDue(nextDueDateDataModal?.vessel_id, nextDueDateDataModal?.typeData?.generated_base_audit_from?.internal_audit_id, nextDueDateDataModal?.type)">{{ nextDueDateDataModal?.typeData?.generated_base_audit_from?.report_number }}</a>
              </span>
              </p>
              <p class="p-1 m-0" >
                - AUDIT END DATE: <span style="font-weight: bold; font-size: 13px">{{ nextDueDateDataModal?.typeData?.generated_base_audit_from?.audit_date_end['human'] }}</span>
              </p>
            </div>

          </template>


        </div>
      </template>
      <template #popperFooter>
      </template>
    </PopperModal>
    <ScheduleAudit ref="schedule_audit"/>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {vueAppMixin} from "@/mixins/vueAppMixin";
import AppLoading from "@/components/elements/AppLoading";

import _ from 'lodash';
import {AlertService} from "@/services/AlertService";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import SorterArrowMixin from "@/mixins/SorterArrowMixin";
import DataCounter from "@/components/common/DataCounter.vue";
import SorterArrow from "@/components/common/SorterArrow.vue";
import DateMixin from "@/mixins/DateMixin";
import MultiSelectWithSearch from "@/components/MultiSelectWithSearch.vue";
import AuditorMixin from "@/mixins/AuditorMixin";
import requestLoaderMixin from "@/mixins/requestLoaderMixin";
import {DataService} from "@/services/DataService";
import TableColumnSearch from "@/components/common/TableColumnSearch.vue";
import DisplayModeVueEditor from "@/components/common/DisplayModeVueEditor.vue";
import PopperModal from "@/components/elements/PopperModal.vue";
import ScheduleAudit from "@/components/modules/ia/vessel/ScheduleAudit.vue"
import ComboBox from "@/components/common/ComboBox.vue";
import DatePicker from 'vue2-datepicker';
import en from "vue2-datepicker/locale/es/en";

export default {

  mixins: [vueAppMixin,PaginationMixin, SorterArrowMixin, DateMixin, AuditorMixin, requestLoaderMixin],
  components: {DisplayModeVueEditor, TableColumnSearch, MultiSelectWithSearch, SorterArrow, DataCounter, AppLoading, ScheduleAudit, PopperModal, ComboBox, DatePicker},

  name: 'VesselAuditDue',
  data() {
    return {
      params: {
        active: 1,
        page:1,
        query: '',
        order_by : 'sms.next_due',
        direction : 'desc',
        category : 'sms',
        office_filter: null,
        vessel_name : null,
        vessel_imo_no : null,
        vessel_flag_name : null,
        vessel_branch_office_name : null,
        vessel_sms_next_due : null,
        vessel_sms_last_audit_date : null,
        vessel_sms_extension : null,
        vessel_isps_next_due : null,
        vessel_isps_last_audit_date : null,
        vessel_isps_extension : null,
        vessel_cyber_next_due : null,
        vessel_cyber_last_audit_date : null,
        vessel_cyber_extension : null,
        plan_type_2 : null,
        plan_audit_type : null,
        plan_extension : null,
        voyage_data : null,
        plan_remarks : null,
        plan_type_3 : null,
        plan_appointment_date : null,
        plan_date_of_audit : null,
        plan_lead_auditor : null,
        plan_non_lead_auditor : null,
        plan_country_name : null,
        plan_port_name : null,
        plan_ap : null,
        plan_do : null,
        plan_nc : null,
        plan_obs : null,
        plan_cor_due_date : null,
        plan_status : null,
      },
      mgmtOffices: [],
      loading: false,
      selectedVesselForPlan : {
        vessel_id : null,
        vessel_name : '',
        place : '',
        auditors : [],
        date : null,
        remarks : ''
      },
      selectedVesselCurrentData : {
        place : '',
        auditors : [],
        date : null,
        remarks : ''
      },
      resetButtonClick : false,
      adjustColumnPixel : '354px',
      smsSortOrder: "ASC",
      ispsSortOrder: "ASC",
      cyberSortOrder: "ASC",
      dataForExcel : {
        audit_dues : null,
        audit_dues_count : {
          sms : null,
          isps : null,
          cyber : null,
        },
      },
      dataForExcelLoading : true,
      typeColors : {
        sms : '#0070c0',
        isps : '#3c7d22',
        cyber : '#808080',
      },
      editPlanRemarksModalData : {
        vessel_audit_due_index : null,
        vessel_name : null,
        data : [],
      },
      editVoyageModalData : {
        vessel_audit_due_index : null,
        vessel_name : null,
        data : [],
      },
      toolbar: [
        ['bold', 'italic', 'strike', 'underline'],
        [{
          'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]
        }]
      ],
      nextDueDateDataModal : null
    }
  },
  methods: {
    ...mapActions([
      'getAuditDues',
      'getAuditDueCounts',
      'getMngmtOfficeKeys',
      'updateAuditDuePlanPlanByVesselId',
      'downloadAuditDueExcel',
      'getReportStatus',
      'updateAuditDueAppointmentDetails',
    ]),
    openBaseReportForAuditNextDue(vessel_id, internal_audit_id, type) {
      const routeData = this.$router.resolve({
        name: 'internalAuditReport',
        params: {
          id: internal_audit_id,
          vessel_id: vessel_id,
          type: type,
        },
      });

      window.open(routeData.href, '_blank');
    },
    setNextDueDateDataModal(vesselData, auditType) {
      this.nextDueDateDataModal = {
        vessel_id : vesselData.id,
        vessel_name : vesselData.vessel_name,
        typeData : vesselData[auditType],
        type : auditType
      };
    },
    highlightRow(vessel_index, add = true) {
      if (add === true) {
        $('.row_' + vessel_index).addClass('list-hover')
      } else {
        $('.row_' + vessel_index).removeClass('list-hover')
      }
    },
    setPlanAuditors(auditors) {
      this.selectedVesselForPlan.auditors = auditors.selected.length > 0 ? auditors.selected : [];
    },
    resetSelectedVesselPlan() {
      this.selectedVesselForPlan = {
        vessel_id : null,
        vessel_name : '',
        place : '',
        auditors : [],
        date : null,
        remarks : ''
      };
      this.selectedVesselCurrentData = {
        place : '',
        auditors : [],
        date : null,
        remarks : ''
      };
      this.resetButtonClick = false;
      $('#updateVesselPlanModal').modal('hide');
    },
    async setDefaultData() {
      this.selectedVesselForPlan.place = '';
      this.selectedVesselForPlan.auditors = [];
      this.selectedVesselForPlan.date = null;
      this.selectedVesselForPlan.remarks = '';
      this.resetButtonClick = true;
    },
    async updateVesselPlan() {
      await this.showLoaderRequest('UPDATING VESSEL PLAN, PLEASE WAIT...');
      const updateResponse = await this.updateAuditDuePlanPlanByVesselId(this.selectedVesselForPlan);
      if (updateResponse.result === false) {
        await this.hideLoaderRequest();
        this.setCollapsedTableColumnsHeight();
        return AlertService.errorAlert(updateResponse.message, 'UPDATING PLAN FOR ' + this.selectedVesselForPlan.vessel_name.toUpperCase());
      }

      const vesselAuditDue = await this.getAuditDues({
        vessel_id : this.selectedVesselForPlan.vessel_id,
        for_audit_plan : true
      });

      let updatedVesselIndex = this.vessel_audit_dues.findIndex(vessel => vessel.id === this.selectedVesselForPlan.vessel_id);
      this.vessel_audit_dues[updatedVesselIndex] = vesselAuditDue[0];
      await this.hideLoaderRequest();
      this.resetSelectedVesselPlan();
      this.setCollapsedTableColumnsHeight();
      AlertService.successAlert('UPDATE SUCCESS', 'UPDATING PLAN FOR ' + this.selectedVesselForPlan.vessel_name.toUpperCase());
      await this.prepareDataForExcel();
    },

    showUpdateVesselPlanModal(vessel) {
      if (this.isAllowed('vessel-ia.appointments.vessel-audit-due.edit-plan') === false) {
        return;
      }
      this.selectedVesselForPlan.vessel_id = vessel.id;
      this.selectedVesselForPlan.vessel_name = vessel.vessel_name.toUpperCase();
      this.selectedVesselForPlan.place = vessel.plan?.place ?? ''
      this.selectedVesselForPlan.auditors = vessel.plan?.auditors.map(auditor => auditor.id) ?? [];
      this.selectedVesselForPlan.date = vessel.plan?.date['date-picker'] ?? null;
      this.selectedVesselForPlan.remarks = vessel.plan?.remarks ?? '';

      const vesselCurrentData = this.vessel_audit_dues.filter(item => item.id === vessel.id);

      this.selectedVesselCurrentData.place = vesselCurrentData[0].plan?.place ?? ''
      this.selectedVesselCurrentData.auditors = vesselCurrentData[0].plan?.auditors.map(auditor => auditor.id) ?? [];
      this.selectedVesselCurrentData.date = vesselCurrentData[0].plan?.date['date-picker'] ?? null;
      this.selectedVesselCurrentData.remarks = vesselCurrentData[0].plan?.remarks ?? '';
      $('#updateVesselPlanModal').modal('show');
    },
    getDueClassColor(type) {
      if (type.overdue === true) {
        return 'overdue';
      }
      if (type['30days'] === true) {
        return 'thirty_days';
      }
      if (type['90days'] === true) {
        return 'ninety_days';
      }
      if (type.overdue === true) {
        return '';
      }
    },
    async setVesselsToTable(page=1) {
      swal.fire({
        'title': `GETTING VESSEL AUDIT DUES REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      this.loading = true;
      this.params.page=page
      this.params.perPage = 40;

      if (this.params.query === '') {
        this.params.query = null;
      }

      if (this.$route.params.vessel_id) {
        await this.getAuditDues({
          vessel_id : this.$route.params.vessel_id
        })
      } else {
        if(this.user?.is_vessel === true){
          await this.getAuditDues({
            vessel_id : this.user?.vessel_id,
          })
        } else{
          await this.getAuditDues(this.params);
        }

      }
      this.loading = false;
      this.setColumnWidths();
      this.setCollapsedTableColumnsHeight()
      swal.close();
    },

    async sortDateColumn(type, column){
      if(this.params.direction === ''){
        this.params.direction = 'asc';
      }
      else if(this.params.direction === 'asc'){
        this.params.direction = 'desc';
      }
      else{
        this.params.direction = 'asc';
      }

      this.params.order_by = column;
      this.params.category = type;

      swal.fire({
        'title': 'Sorting The Vessel Audit Information',
        text: 'Please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
      swal.showLoading();
      this.prepareDataForExcel();
      await this.getAuditDues(this.params);
      swal.close();
    },

    async viewAuditRecord(vessel_id,audit_id,type) {
      const routeData = this.$router.resolve({
        name: 'AppointmentDetails',
        params: {
          id: audit_id,
          vessel_id: vessel_id,
          type: type,
        },
      });

      window.open(routeData.href, '_blank');
    },
    runCallBack(param) {
      this.params.order_by = param.orderBy;
      this.params.direction = param.direction;
      if (param.direction === '') {
        this.currentOrderBy = '';
      }
      this.setVesselsToTable(1);
    },
    setColumnWidths() {
      setTimeout(() => {
        const pageHasScrollBar = document.documentElement.scrollHeight > document.documentElement.clientHeight;

        if (pageHasScrollBar === true) {
          this.adjustColumnPixel = '354px';
        } else {
          this.adjustColumnPixel = '344px';
        }
      }, 1)
    },
    setCollapsedTableColumnsHeight() {
      setTimeout(() => {
        const collapsibleTableRows = $('#collapsible_table').find('tbody tr');
        const dataTableRows = $('#data_table').find('tbody tr');

        for (let counter = 0; counter < collapsibleTableRows.length; counter++) {
          let rowHeight = $(collapsibleTableRows[counter]).height();
          $(dataTableRows[counter]).height(rowHeight);
        }
      }, 1)
    },
    async prepareDataForExcel() {
      this.dataForExcelLoading = true;
      let params = Object.assign({}, this.params);
      delete params.perPage;
      params.excel = true;
      this.dataForExcelLoading = false;
    },
    async exportData() {
      const newParams = {};

      for (let key in this.params) {
        const invalidValues = [null, undefined, ''];
        if (invalidValues.includes(this.params[key]) === false) {
          newParams[key] = this.params[key];
        }
      }

      if (this.user?.is_vessel) {
        newParams.vessel_id = this.user?.vessel_id;
      }

      this.dataForExcel = newParams;
      this.dataForExcel.audit_dues_count = {
        sms : this.vessel_audit_dues_count.sms,
        isps : this.vessel_audit_dues_count.isps,
        cyber : this.vessel_audit_dues_count.cyber,
      };

      swal.fire({
        'title': `GENERATING VESSEL AUDIT DUES REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const response = await this.downloadAuditDueExcel(this.dataForExcel);
      swal.close();

      if (response === false) {
        return AlertService.errorAlert('Theres an error downloading the file. Please try again later!', 'DOWNLOADING FILE');
      }

      let mime_type = 'application/vnd.ms-excel';
      let url = window.URL.createObjectURL(new Blob([response],{type:mime_type}))

      let filename=`AUDIT_PLAN.xlsx`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    convertAuditType2IntoType(audit_type_2) {
      if (audit_type_2 === 1) {
        return {
          text: 'A',
          color: '#0022f3',
          name : 'Annual Audit'
        };
      }

      if (audit_type_2 === 2) {
        return {
          text: 'O',
          color: '#ee1b24',
          name : 'Occasional Audit'
        };
      }

      if (audit_type_2 === 3) {
        return {
          text: 'N',
          color: '#3f47cb',
          name : 'Navigational Audit'
        };
      }
      return {
        text: '',
        color: '',
        name : ''
      };

    },
    convertAuditType3IntoType(audit_type_3) {
      if (audit_type_3 === 1) {
        return {
          text: 'O',
          color: '#808080',
          name : 'Onsite'
        };
      }

      if (audit_type_3 === 2) {
        return {
          text: 'R',
          color: '#24b04f',
          name : 'Remote'
        };
      }

      return {
        text: '',
        color: '',
        name : ''
      };
    },
    createNewAppointment(vesselId) {
      this.$refs.schedule_audit.setVesselId(vesselId)
      $('#ScheduleNewVesselAuditModal').modal('show');
    },
    filterAuditorsByPosition(auditors) {
      let filteredAuditors = {
        leaders : [],
        members : []
      };
      if (auditors.length > 0) {
        auditors.forEach((auditor) => {
          if (auditor.pivot.is_lead === 1) {
            filteredAuditors.leaders.push(auditor);
          } else {
            filteredAuditors.members.push(auditor);
          }
        });
      }
      return filteredAuditors;
    },
    checkAllRequiredFilled(audit_planner) {
      const invalidValue = [null, undefined];
      let extensionValidation = true;

      if (audit_planner?.extension !== null && audit_planner.extension === 1) {
        extensionValidation = audit_planner.extended_date.human !== null
      }

      let ca_security_director_validation = false;
      let approval_security_director_validation = false;

      if (audit_planner.type === 'sms') {
        ca_security_director_validation = invalidValue.includes(audit_planner.audit_report.ca_ship_management_director_id) === false;
        approval_security_director_validation = invalidValue.includes(audit_planner.audit_report.approval_ship_management_director_id) === false;
      }

      if (audit_planner.type === 'isps') {
        ca_security_director_validation = invalidValue.includes(audit_planner.audit_report.ca_company_officer_id) === false
        approval_security_director_validation = invalidValue.includes(audit_planner.audit_report.approval_company_officer_id) === false;
      }

      if (audit_planner.type === 'cyber') {
        ca_security_director_validation = invalidValue.includes(audit_planner.audit_report.ca_company_cyber_officer_id) === false
        approval_security_director_validation = invalidValue.includes(audit_planner.audit_report.approval_company_cyber_officer_id) === false;
      }

      let reason_of_audit_validation = true;

      if (audit_planner.audit_type_2.length === 1 && audit_planner.audit_type_2[0] === 2) {
        reason_of_audit_validation = audit_planner.reason_of_audit !== null;
      }

      let evidence_of_approval_validation = true;

      if (audit_planner.extension !== null && audit_planner.extension === 1 && audit_planner.received_approval === 1) {
        evidence_of_approval_validation = audit_planner.evidence_of_approval !== null;
      }

      let caDoneLaterDone = audit_planner.audit_report.ca_done_later_than['date-picker'] !== null;
      let caTimeLimitDate = audit_planner.audit_report.ca_time_limit_date['date-picker'] !== null;
      let caImplementedDate = audit_planner.audit_report.ca_implemented_date['date-picker'] !== null;
      let caImplementedMaster = audit_planner.audit_report.ca_implemented_master !== null;
      let caConfirmationDate = audit_planner.audit_report.ca_confirmation_date['date-picker'] !== null;
      let caConfirmationAuditLeader = audit_planner.audit_report.ca_confirmation_audit_leader !== null;

      if (audit_planner.audit_report.has_ncr_obs === 0) {
        caDoneLaterDone = true;
        caTimeLimitDate = true;
        caImplementedDate = true;
        caImplementedMaster = true;
        caConfirmationDate = true;
        caConfirmationAuditLeader = true;
        ca_security_director_validation = true;
      }

      return (
        (extensionValidation) &&
        (audit_planner.audit_type_2.length > 0) &&
        (audit_planner.audit_type_3.length > 0) &&
        (audit_planner.audit_date_start.human !== null && audit_planner.audit_date_end.human !== null) &&
        (audit_planner.appointment_date.human !== null) &&
        (audit_planner.country_id !== null) &&
        (this.filterAuditorsByPosition(audit_planner.auditors).leaders.length !== 0) &&
        (audit_planner.audit_report.attendance_url !== null) &&
        (caDoneLaterDone) &&
        (caTimeLimitDate) &&
        (ca_security_director_validation) &&
        (caImplementedDate) &&
        (caImplementedMaster) &&
        (caConfirmationDate) &&
        (caConfirmationAuditLeader) &&
        (audit_planner.audit_report.audit_approval_date['date-picker'] !== null) &&
        (approval_security_director_validation) &&
        (reason_of_audit_validation) &&
        (evidence_of_approval_validation)
      );
    },
    getNcrObsBgColor(audit_planner, column_name = 'AP') {
      const CLOSED = 3;
      const READY_TO_CLOSE = 4;

      const allRequiredFilled = this.checkAllRequiredFilled(audit_planner);

      let color = '#fff';

      if (audit_planner.report_status_id === CLOSED) {
        color = '#a6a6a6';
      } else if (audit_planner.report_status_id === READY_TO_CLOSE) {
        color = '#00b0f0';
      } else {
        if (allRequiredFilled === true) {
          color = '#00b0f0';
        }

        if (column_name !== 'AP') {
          if ((audit_planner.ncr_count > 0 || audit_planner.obs_count > 0)) {
            color = '#ffc000';
          }
        }


      }
      return color;
    },
    disableCreateAppointmentWhenTypeIsNew(typeStatus){
      if (!typeStatus || typeStatus.length === 0) return false;
      const targetStatusId = this.selectedReportStatusKey['new']?.id || 1;

      return typeStatus.some(val => val.report_status_id === targetStatusId);
    },
    getSameDataFromType(reports, dataKey, is_lead_auditor = 0) {
      let previousType = null;
      let currentType = null;
      let previousData = null;
      let currentData = null;
      let typesHaveSameData = {};
      const CLOSED = 3;

      reports.forEach((record, index) => {

        if (currentType !== null) {
          previousType = currentType;
          previousData = currentData;
        }
        currentType = reports[index].type;

        if (dataKey === 'auditor_ids') {
          record.auditor_ids = record.auditors.filter(auditor => auditor?.pivot?.is_lead === is_lead_auditor).map(auditor => auditor.id);
        }

        if (dataKey === 'is_extended_value') {
          if (record.report_status_id === CLOSED) {
            record.is_extended_value = null;
          } else {
            record.is_extended_value = record.is_extended === 0 ? null : index;
          }
        }

        if (dataKey === 'extension_approval_value') {

          if (record.report_status_id === CLOSED) {
            record.extension_approval_value = null;
          } else {
            record.extension_approval_value = record.extension_approval_url === null ? null : record.extension_approval_url;
          }
        }

        if (dataKey === 'appointment_date_picker') {
          record.appointment_date_picker = record.appointment_date['date-picker'] ?? null;
        }

        if (dataKey === 'audit_start_end_date') {
          record.audit_start_end_date = (record.audit_date_start['date-picker'] ?? '') + '-' + (record.audit_date_end['date-picker'] ?? '');
        }

        if (dataKey === 'ca_done_later_than_date_value') {
          record.ca_done_later_than_date_value = record?.audit_report?.ca_done_later_than['date-picker'] ?? null;
        }

        if (dataKey === 'ap_ncr_obs_cor_value' && record.report_status_id === CLOSED) {
          record.ap_ncr_obs_cor_value = null;
        }

        if (dataKey === 'audit_done' && record.report_status_id === CLOSED) {
          record.audit_done = null;
        }

        currentData = record[dataKey];

        if (previousType !== null && currentType !== null) {
          let newPrevData = null;
          let newCurrentData = null;
          if (Array.isArray(previousData) === true) {
            newPrevData = [];
            previousData.forEach(item => {
              newPrevData.push(item);
            })
          } else {
            newPrevData = previousData;
          }

          if (Array.isArray(currentData) === true) {
            newCurrentData = [];
            currentData.forEach(item => {
              newCurrentData.push(item);
            })
          } else {
            newCurrentData = currentData;
          }

          let prev_data = {
            data : newPrevData
          }

          let current_data = {
            data : newCurrentData
          }

          const same = DataService.checkIfChanged(prev_data, current_data) === false;

          if (same === true) {
            if (!(previousType in typesHaveSameData)) {
              typesHaveSameData[previousType] = true;
            }

            if (!(currentType in typesHaveSameData)) {
              typesHaveSameData[currentType] = false;
            }
          }
        }
      });
      return typesHaveSameData;
    },
    editVoyageData(index, vessel) {
      let reportIsCreatedByUser = true;

      const auditTypes = vessel?.internal_audit_planner?.audit_types.map((item, audit_type_index) => {
        if (reportIsCreatedByUser === true && this.user.id !== item.created_by_id) {
          reportIsCreatedByUser = false;
        }
        return {
          id : item?.appointment_details_id,
          edit : false,
          type_id : item.id,
          type : item.type,
          voyage_data : item.voyage_data,
          original_voyage_data : item.voyage_data,
          report_status_id : item.report_status_id,
          audit_type_index : audit_type_index,
          vessel_audit_due_index : index,
        }
      }).filter(item => {
        return item.report_status_id !== 3;
      });

      if (reportIsCreatedByUser === false && this.isAllowed('vessel-ia.appointment.appointment.edit-voyage-only') === false) {
        return AlertService.errorAlert('You are not allowed to edit voyage data', 'EDIT VOYAGE DATA');
      }

      this.editVoyageModalData = {
        vessel_name : vessel?.vessel_name,
        data : auditTypes,
      }

      if (auditTypes.length > 0) {
        $('#editVoyageDataModal').modal('show');
      }
    },
    editPlanRemarks(index, vessel) {
      let reportIsCreatedByUser = true;

      const auditTypes = vessel?.internal_audit_planner?.audit_types.map((item, audit_type_index) => {
        if (reportIsCreatedByUser === true && this.user.id !== item.created_by_id) {
          reportIsCreatedByUser = false;
        }
        return {
          id : item?.appointment_details_id,
          edit : false,
          type_id : item.id,
          type : item.type,
          plan_remarks : item.plan_remarks,
          original_plan_remarks : item.plan_remarks,
          report_status_id : item.report_status_id,
          audit_type_index : audit_type_index,
          vessel_audit_due_index : index,
        }
      }).filter(item => {
        return item.report_status_id !== 3;
      });

      if (reportIsCreatedByUser === false && this.isAllowed('vessel-ia.appointment.appointment.edit-details') === false) {
        return AlertService.errorAlert('You are not allowed to edit plan remarks', 'EDIT PLAN REMARKS');
      }

      this.editPlanRemarksModalData = {
        vessel_name : vessel?.vessel_name,
        data : auditTypes,
      }

      if (auditTypes.length > 0) {
        $('#editPlanRemarksModal').modal('show');
      }


    },
    redirectToMainReport(vessel, audit_planner, statusColumn = true) {
      if (statusColumn === false && audit_planner.report_status_id === 3) {
        return;
      }
      const route= this.$router.resolve(
        {
          name: 'AppointmentDetails',
          params: {
            type : audit_planner.type,
            id : vessel.internal_audit_planner.id,
            vessel_id : vessel.id
          },
        },
      )
      window.open(route.href,'_blank')
    },
    viewEvidenceOfApproval(evidence_of_approval_url) {
      window.open(evidence_of_approval_url,'_blank');
    },
    computeCorDueDateFromToday(audit_planner) {
      const corDueDate = audit_planner?.audit_report?.ca_done_later_than['date-picker'];
      let color = '';
      let number_of_days_remaining = 0;

      if ((audit_planner?.audit_report.has_ncr_obs === true || audit_planner?.audit_report.has_ncr_obs === 1) && audit_planner?.audit_report?.ca_done_later_than.human !== null) {
        const today = new Date();
        const target = new Date(corDueDate);
        const diffMs = target - today;
        number_of_days_remaining = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        if (audit_planner.report_status_id !== 3) {
          if (number_of_days_remaining <= 0) {
            color = 'red';
          } else if (number_of_days_remaining <= 30) {
            color = 'orange';
          }
        }
      }

      return {
        number_of_days_rem : number_of_days_remaining,
        color
      };
    },
    cancelEditVoyageData(item) {
      item.edit = false;
      item.voyage_data = item.original_voyage_data;
    },
    cancelEditPlanRemarks(item) {
      item.edit = false;
      item.plan_remarks = item.original_plan_remarks;
    },
    closePlanRemarksModal() {
      this.editPlanRemarksModalData = {
        vessel_audit_due_index : null,
        vessel_name : null,
        data : [],
      };
    },
    closeVoyageDataModal() {
      this.editVoyageModalData = {
        vessel_audit_due_index : null,
        vessel_name : null,
        data : [],
      };
    },
    triggerFormRefresh(){
      //TRIGGER FOR PLAN REMARKS AND VOYAGE DATA
      const updateAppointment = {
        vessel_id: Math.random(),
        id: Math.random(),
        unique: Math.random(),
      }
      localStorage.setItem('newAppointmentAuditDue', JSON.stringify([updateAppointment]))
    },
    async saveVoyageData(item) {
      swal.fire({
        'title': 'Updating Appointment Details, please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      })

      swal.showLoading()

      const response = await this.updateAuditDueAppointmentDetails({
        id : item.id,
        type_id : item.type_id,
        type : item.type,
        voyage_data : item.voyage_data
      });

      item.edit = false;
      swal.close();
      if (response.result === false) {
        return AlertService.errorAlert(response.message, 'SAVING APPOINTMENT DETAILS FOR VOYAGE DATA')
      }

      //TRIGGER FOR PLAN REMARKS AND VOYAGE DATA
      this.triggerFormRefresh()

      item.original_voyage_data = item.voyage_data;
      this.vessel_audit_dues[item.vessel_audit_due_index].internal_audit_planner.audit_types[item.audit_type_index].voyage_data = item.voyage_data;

      swal.close();
      AlertService.successAlert('Successfully saved data','UPDATE')
    },
    async savePlanRemark(item) {
      swal.fire({
        'title': 'Updating Appointment Details, please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      })

      swal.showLoading()

      const response = await this.updateAuditDueAppointmentDetails({
        id : item.id,
        type_id : item.type_id,
        type : item.type,
        plan_remarks : item.plan_remarks
      });

      item.edit = false;
      swal.close();
      if (response.result === false) {
        return AlertService.errorAlert(response.message, 'SAVING APPOINTMENT DETAILS FOR PLAN REMARKS')
      }

      //TRIGGER FOR PLAN REMARKS AND VOYAGE DATA
      this.triggerFormRefresh()

      item.original_plan_remarks = item.plan_remarks;
      this.vessel_audit_dues[item.vessel_audit_due_index].internal_audit_planner.audit_types[item.audit_type_index].plan_remarks = item.plan_remarks;

      swal.close();
      AlertService.successAlert('Successfully saved data','UPDATE')


    },
    async saveAuditDoneChanges(item) {
      swal.fire({
        'title': 'Updating Appointment Details for Audit Done, please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      })

      swal.showLoading()

      const response = await this.updateAuditDueAppointmentDetails({
        id : item?.appointment_details_id,
        type_id : item.id,
        type : item.type,
        is_audit_done : item.is_audit_done
      });


      swal.close();
      if (response.result === false) {
        return AlertService.errorAlert(response.message, 'SAVING APPOINTMENT DETAILS FOR AUDIT DONE')
      }

      item.orig_is_audit_done = item.is_audit_done;

      swal.close();
      AlertService.successAlert('Successfully saved data','UPDATE')

    }
  },
  computed: {
    en() {
      return en
    },
    DataService() {
      return DataService
    },
    ...mapGetters([
      'pagination',
      'isLoading',
      'vessel_audit_dues',
      'vessel_audit_dues_count',
      'mngmntOfficeKeys',
      'mngmtCompanyKeys',
      'reportStatusKeys',
      'updated_report_status_names',
      'newAppointmentAuditDueRefs',
      'user',
    ]),
    hasChanges() {
      const originalData = {
        auditors : this.selectedVesselCurrentData.auditors,
        date : this.selectedVesselCurrentData.date,
        place : this.selectedVesselCurrentData.place,
        remarks : this.selectedVesselCurrentData.remarks
      }

      const editedData = {
        auditors : this.selectedVesselForPlan.auditors,
        date : this.selectedVesselForPlan.date,
        place : this.selectedVesselForPlan.place,
        remarks : this.selectedVesselForPlan.remarks
      }
      return DataService.checkIfChanged(originalData, editedData);
    },
    dateRangePlanAppointmentDate: {
      get() {
        return this.params.plan_appointment_date || [null, null]
      },
      set(val) {
        this.params.plan_appointment_date = Array.isArray(val) && val.every(v => v === null) ? null : val
      }
    },
    dateRangePlanDateOfAudit: {
      get() {
        return this.params.plan_date_of_audit || [null, null]
      },
      set(val) {
        this.params.plan_date_of_audit = Array.isArray(val) && val.every(v => v === null) ? null : val
      }
    },
    selectedReportStatusKey(){
      return this.reportStatusKeys.reduce((acc, item) => {
        acc[item.code] = item;
        return acc;
      }, {});
    },
    reportStatusKeyModify(){
      const renameMap = {
        new: 'APPOINTED',
        open: 'IN PROGRESS'
      }

      return this.reportStatusKeys.map(v => ({
        ...v,
        name: renameMap[v.code] ?? v.name
      }))
    },
    allDuesCountRequested() {
      return this.vessel_audit_dues_count.sms.overdue.requesting === false &&
        this.vessel_audit_dues_count.sms['30days'].requesting === false &&
        this.vessel_audit_dues_count.sms['90days'].requesting === false &&
        this.vessel_audit_dues_count.isps.overdue.requesting === false &&
        this.vessel_audit_dues_count.isps['30days'].requesting === false &&
        this.vessel_audit_dues_count.isps['90days'].requesting === false &&
        this.vessel_audit_dues_count.cyber.overdue.requesting === false &&
        this.vessel_audit_dues_count.cyber['30days'].requesting === false &&
        this.vessel_audit_dues_count.cyber['90days'].requesting === false;
    }
  },
  async created() {
    this.loading = true;
    this.setVessels = _.debounce(this.setVesselsToTable, 750)
    await this.getMngmtOfficeKeys();
    await this.setVesselsToTable();
    await this.prepareDataForExcel();
    await this.getAuditDueCounts();
    await this.getReportStatus();
  },
  watch: {
    'params.active'() {
      this.setVessels()
    },
    newAppointmentAuditDueRefs: {
      async handler() {
        //TRIGGER FOR PLAN REMARKS AND VOYAGE DATA
        $('#editVoyageDataModal').modal('hide')
        $('#editPlanRemarksModal').modal('hide')
        this.closeVoyageDataModal()
        this.closePlanRemarksModal()

        $('#ScheduleNewVesselAuditModal').modal('hide');
        await this.setVesselsToTable()
      },
      deep: true
    },
  },

  destroyed() {
    this.params.active = 1;
  }

}
</script>

<style scoped>
select option:checked {
  background-color: #d3d3d3; /* Light gray */
  color: #000; /* Black text for contrast */
}

.select-null{
  color: #718b9b;
}

.left-solid-border-black {
  border-left: 1px solid black !important;
}

.right-solid-border-black {
  border-right: 1px solid black !important;
}

.all-solid-border-black {
  border: 1px solid black !important;
}

.top-solid-border-black{
  border-top: 1px solid black !important;
}

.bottom-solid-border-black{
  border-bottom: 1px solid black !important;
}

.overdue {
  color: #fffeff;
  background-color: #ff0000;
}

.thirty_days {
  color: #fffeff;
  background-color: #ffa500;
}

.ninety_days {
  background-color: #f3f309;
}

.plan-content {
  background-color: #ccffff;
}

.plan-data {
  border: 1px solid black !important;
}

.table-container {
  overflow-x: auto;
  margin-bottom: 1%;
}

table {
  border-collapse: separate;
  background-color: #fff;
  border: 1px solid #ddd;
  border-spacing: 0;

}

th,
td {
  padding: 8px;
  white-space: nowrap;
  background: #ffffff;
  border: 1px solid #ddd;
  vertical-align: middle;
}

.fixed-col {
  position: sticky;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.fixed-col:nth-child(2) {
  left: 2.5em;
}
.fixed-col:nth-child(3) {
  left: 17.1em;
}
.fixed-col:nth-child(4) {
  left: 26em;
}
.fixed-col:nth-child(5) {
  left: 35.4em;
  box-shadow: 0px 0 0 #e1e1e1, 2px 0 0 #e1e1e1;
}

.circle-badge {
  width: 20px;
  height: 20px;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin: auto;
}

.arrow-border {
  width: 25px;
  height: 20px;
  background-color: black;
  clip-path: polygon(0 0, 70% 0, 100% 50%, 70% 100%, 0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 2px 2px 2px; /* border thickness */
  box-sizing: border-box;
  margin: auto;
}

.arrow-fill {
  width: 100%;
  height: 100%;
  clip-path: inherit;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 8px;
  font-size: 10px;
}

.table-height {
  overflow-y: auto;
  //max-height: 735px !important;
  height: 80vh !important;
}

.type-text {
  position: absolute;
  left: -20px;
  font-family: Arial Black, sans-serif;
  font-weight: 900;
  color: #ff0000;
  z-index: 1000;
  background-color: white;
  padding : 2px;
  border: 1px solid gray;
  font-size: 7px;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-container input {
  width: 100%;
  padding-right: 35px; /* space for the icon */
}

.search-icon {
  position: absolute;
  right: 8px;
  background-color: #cce7ff; /* light blue */
  border-radius: 5px;
  padding: 5px 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.search-icon:hover {
  background-color: #007bff; /* blue on hover */
  color: white;
}

.redirect-column:hover {
  border: 2px solid black !important;
}
.no-border-table {
  border:none !important;
}
.no-border-table th,
.no-border-table td,
.no-border-table tr
{
  border:none !important;
}
.no-border-table tr > td:nth-child(2){
  display:flex;
  align-items: center;
  gap:5px;
}
.no-border-table tr > td:nth-child(2) > div:nth-child(1){
    white-space: nowrap;
    width: 350px !important;
    overflow: hidden;
    text-overflow: ellipsis;
}

.box-legend{
  height: 25px;
  width:115px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-legend.appointed{ background-color: #42b983; color:white; }
.box-legend.in-progress{ background-color: #056cb4; color:white; }
.box-legend.ready-to-close{ background-color: #042454; color:white; }
.box-legend.closed{ background-color: #4C4C4C;color:white; }

#audit_done_select:hover {
  border: 1px solid black;
}

button#button-cancel {
  padding: 0;
  background-color: transparent;
  border: 0;
}

.cancel-edit-button {
  font-size: 25px;
  color: red;
  opacity: 0.8;
}

.cancel-edit-button:hover {
  opacity: 1;
}


.e-text-green {
  opacity: 0.8 !important;
}

.e-text-green:hover {
  opacity: 1 !important;
}


@media screen and (max-width: 1600px) {
  .fixed-col:nth-child(2) {
    left: 2.3em;
  }
  .fixed-col:nth-child(3) {
    left: 16.9em;
  }
  .fixed-col:nth-child(4) {
    left: 26.1em;
  }
  .fixed-col:nth-child(5) {
    left: 35.6em;
    box-shadow: 0px 0 0 #e1e1e1, 2px 0 0 #e1e1e1;
  }
  .table-height{
    overflow-y: auto;
    max-height: 725px !important;
  }
}

@media screen and (min-width: 2560px) {
  .fixed-col:nth-child(2) {
    left: 2.5em;
  }
  .fixed-col:nth-child(3) {
    left: 17.1em;
  }
  .fixed-col:nth-child(4) {
    left: 26.4em;
  }
  .fixed-col:nth-child(5) {
    left: 35.96em;
    box-shadow: 0px 0 0 #e1e1e1, 2px 0 0 #e1e1e1;
  }
  .table-height{
    overflow-y: auto;
    max-height: 900px !important;
  }
}

@media screen and (min-width: 3440px) {
  .fixed-col:nth-child(2) {
    left: 1.04em;
  }
  .fixed-col:nth-child(3) {
    left: 6.47em;
  }
  .fixed-col:nth-child(4) {
    left: 9.96em;
  }
  .fixed-col:nth-child(5) {
    left: 13.5em;
    box-shadow: 0px 0 0 #e1e1e1, 2px 0 0 #e1e1e1;
  }
  .table-height{
    overflow-y: auto;
    max-height: 1245px !important;
  }
}

@media (min-width: 3840px) and (min-height: 1600px) {
  .fixed-col:nth-child(2) {
    left: 0.9em;
  }
  .fixed-col:nth-child(3) {
    left: 5.72em;
  }
  .fixed-col:nth-child(4) {
    left: 8.79em;
  }
  .fixed-col:nth-child(5) {
    left: 11.93em;
    box-shadow: 0px 0 0 #e1e1e1, 2px 0 0 #e1e1e1;
  }
  .table-height{
    overflow-y: auto;
    max-height: 1410px !important;
  }
}

@media (min-width: 3840px) and (max-height: 1080px) {
  .fixed-col:nth-child(2) {
    left: 0.9em;
  }
  .fixed-col:nth-child(3) {
    left: 5.72em;
  }
  .fixed-col:nth-child(4) {
    left: 8.79em;
  }
  .fixed-col:nth-child(5) {
    left: 11.93em;
    box-shadow: 0px 0 0 #e1e1e1, 2px 0 0 #e1e1e1;
  }
  .table-height{
    overflow-y: auto;
    max-height: 890px !important;
  }
}
.custom-padding tr td {
  padding: 3px !important;
}
.form-control-xs {
  height: calc(1.5em + 0rem + 1px);
  padding: 0rem .5rem;
  font-size: 8.65pt;
  line-height: 1.5;
  border-radius: .2rem;
}

/* STICKY HEADER */
thead th {
  position: sticky !important;
}

thead tr:first-child th[colspan] {
  z-index: 7;
}

thead tr:nth-child(1) th {
  top: 0;
  z-index: 8;
}

thead tr:nth-child(2) th {
  top: 98px;
  z-index: 7;
}

thead tr:nth-child(3) th {
  top: 142px;
  z-index: 6;
}

thead tr:nth-child(4) th {
  top: 180px;
  z-index: 9;
}

.z-index-7 {
  z-index: 7 !important;
}
/* STICKY HEADER */
</style>
